
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.093 16.833v-2.342h2.233c1.57 0 3.23-.412 3.252-1.822 0-.867-.708-2.017-3.186-2.017-1.371 0-3.23.477-3.23 1.865H.244c0-3.275 3.319-4.467 6.172-4.467 2.92 0 6.062 1.387 6.084 4.62 0 1.192-.796 2.58-2.146 2.992 1.482.477 2.522 1.909 2.522 3.188 0 3.709-3.562 4.815-6.548 4.815-2.942 0-6.305-1.214-6.327-4.663h2.942c0 1.562 2.146 2.104 3.407 2.104 1.482 0 3.451-.607 3.451-2.234 0-.911-.509-2.039-3.296-2.039H4.093zM17.764 12.929v2.277c.686-1.041 2.367-1.605 3.584-1.605 3.119 0 6.393 1.28 6.393 5.053 0 3.362-3.296 5.032-6.415 5.032-3.163 0-6.46-1.67-6.46-5.075v-5.66c0-3.384 3.186-4.967 6.372-4.967 3.362 0 6.349 1.302 6.349 4.49h-2.92c0-1.345-1.726-2.017-3.385-2.017-1.748-.022-3.518.91-3.518 2.558v-.086zm7.079 5.725c0-1.67-1.549-2.558-3.495-2.558-1.947 0-3.606.868-3.584 2.558.022 1.67 1.659 2.473 3.561 2.473 1.838 0 3.518-.802 3.518-2.473zM41.214 10.977H32.85v2.667h3.01c3.296 0 6.238 1.323 6.216 4.88 0 3.449-2.942 5.097-6.061 5.097-3.407 0-6.327-1.193-6.35-4.75h2.897c0 1.67 1.947 2.104 3.407 2.104 1.416 0 3.208-.65 3.208-2.45.022-1.714-1.726-2.213-3.318-2.213h-5.862V8.287h11.216v2.69zM64.987 0a2.722 2.722 0 00-1.309 5.109l-5.522 13.53a2.722 2.722 0 00-2.29.238l-5.87-6.719a2.718 2.718 0 10-.726.635l5.87 6.719a2.71 2.71 0 00-.597 1.7c0 1.503 1.068 2.721 2.722 2.721s2.722-1.218 2.722-2.721a2.716 2.716 0 00-.984-2.095l5.591-13.702A2.722 2.722 0 1064.987 0z","fill":"#fff"}})])
          )
        }
      }
    